import React from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';

const createStyles = (theme) =>
  StyleSheet.create({
    container: {
      padding: theme.productsPerPage >= 40 ? 2 : (theme.productsPerPage > 30 ? 3 : 5),
      backgroundColor: theme.categoryBg || 'yellow',
      marginBottom: theme.productsPerPage >= 40 ? 1 : 2,
    },
    title: {
      fontSize: theme.headerFontSize || 12,
      fontWeight: 'bold',
      textAlign: 'center',
      color: theme.categoryText || 'black',
      fontFamily: theme.fontFamily,
    },
  });

const Category = ({ title, discount, discountToggle, pageIndex, theme = {} }) => {
  const styles = createStyles(theme);
  const showDiscountLabel = theme.showCategoryDiscountText !== false;

  return (
    <View style={styles.container}>
      <Text style={styles.title}>
        {title}
        {discount > 0 && discountToggle && showDiscountLabel ? (
          <Text style={{ fontWeight: 'bold', color: theme.categoryText || 'black' }}> (Discount: {discount}%)</Text>
        ) : null}
      </Text>
    </View>
  );
};

export default Category;